
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hZy36 = parcelRequire("hZy36");

var $3H7QB = parcelRequire("3H7QB");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-41c59b627f";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
(0, $hZy36.configureCastle)();
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    // In Uniform Playground (preview authoring environment), skip OneTrust check
    // and assume performance tracking is enabled — mirrors OneTrustProvider behavior.
    // Cookies are unavailable in the cross-origin iframe context, so the normal
    // cookie-based check always returns false for CPRA users (e.g. California).
    const isPerfOnetrustEnabled = window.isUniformPlayground || (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(async ()=>{
        try {
            await (0, $3H7QB.DynamicConfigClient).getInstance().initialize({
                bootstrapValues: window.featureGateBootstrapValues
            });
        } catch (error) {
            console.error("Failed to initialize DynamicConfigClient", error);
        }
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? "" : pathForCanonical === "" ? "" : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${canonicalBaseUrl}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${canonicalBaseUrl}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    channel: window.channel,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-expect-error type
            const root = (0, $konOj.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else // @ts-expect-error type
        (0, $konOj.hydrateRoot)(document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById("wac-root")?.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("keOu4", function(module, exports) {
$parcel$export(module.exports, "JiraTemplateCategoryPage", function () { return $35f22ae28293b9db$export$52bd3b9163994b81; });

var $7VQPk = parcelRequire("7VQPk");

var $5eEVK = parcelRequire("5eEVK");
const $35f22ae28293b9db$export$52bd3b9163994b81 = ({ templates: templates })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $5eEVK.JiraTemplateCategoryPageTemplate), {
        templates: templates
    });

});
parcelRegister("5eEVK", function(module, exports) {
$parcel$export(module.exports, "JiraTemplateCategoryPageTemplate", function () { return $53c56b844af24133$export$8ae757bfa7e42dde; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $eY3N6 = parcelRequire("eY3N6");

var $20OkY = parcelRequire("20OkY");

var $gMME0 = parcelRequire("gMME0");

var $1rObi = parcelRequire("1rObi");

var $6iKF0 = parcelRequire("6iKF0");

var $jBOxZ = parcelRequire("jBOxZ");

var $jsxHL = parcelRequire("jsxHL");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $7ASVM = parcelRequire("7ASVM");

var $8Sr8q = parcelRequire("8Sr8q");

var $8AvPJ = parcelRequire("8AvPJ");

var $2fCHu = parcelRequire("2fCHu");
const $53c56b844af24133$var$PageContent = ({ templates: templates })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8AvPJ.SharedHeaderFooterContainer), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $jsxHL.TypographyStyles), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fCHu.TemplatesGrid), {
                        templates: templates ?? (0, $7ASVM.JSM_TEMPLATES_CONTENT)
                    })
                }),
                (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).wacUnifiedTemplatesNavigation) && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jBOxZ.UnifiedTemplatesNavigationSection), {
                    product: "jiraServiceManagement"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8Sr8q.Resources), {})
            ]
        })
    });
};
const $53c56b844af24133$export$8ae757bfa7e42dde = ({ templates: templates })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const fireSLOErrorEvent = (0, $1oC0p.useCallback)((error)=>{
        createAnalyticsEvent({
            product: "marketing",
            eventType: "operational",
            actionSubject: "wacJsmTemplateScreenFailed",
            action: "failed",
            attributes: {
                errorMessage: error?.message || error
            }
        }).fire();
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)($53c56b844af24133$var$PageContent, {
            templates: templates
        }),
        onError: (e)=>fireSLOErrorEvent(e),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gMME0.CrossFlowProvider), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rObi.CrossFlowTouchpointProvider), {
                productKeys: [
                    (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK
                ],
                screenName: "wacJsmTemplateScreen",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($53c56b844af24133$var$PageContent, {
                    templates: templates
                })
            })
        })
    });
};

});
parcelRegister("7ASVM", function(module, exports) {
$parcel$export(module.exports, "JSM_TEMPLATES_CONTENT", function () { return $44530ce77f7794c2$export$a582b1f9bb954226; });
const $44530ce77f7794c2$export$a582b1f9bb954226 = [
    {
        templateId: "it-service-management",
        name: "IT service management",
        oneLinerHeadline: "Intake requests, set up alerts, raise incidents, and fix issues quickly.",
        urlSlug: "it-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/ug362u6qv3ywnwcca17012vsdfpwcu1j.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Alerts and on-call schedules",
                iconRef: "alert-icon"
            },
            {
                name: "Multi-channel support",
                iconRef: "headphone-icon"
            }
        ]
    },
    {
        templateId: "advanced-it-service-management",
        name: "Advanced IT service management",
        oneLinerHeadline: "Incident, change, and problem management with ITSM best practices.",
        urlSlug: "advanced-it-service-management",
        templateIcon: {
            name: "Help Center screenshot",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/3fte56b800hsu0n8r76727ht510v7808.svg",
            description: "Help Center screenshot"
        },
        keyFeatures: [
            {
                name: "Automated change requests",
                iconRef: "check-task-icon"
            },
            {
                name: "Alerts and on-call schedules",
                iconRef: "alert-icon"
            }
        ]
    },
    {
        templateId: "hr-service-management",
        name: "HR service management",
        oneLinerHeadline: "Manage onboarding and offboarding and respond to HR requests.",
        urlSlug: "hr-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/cre6xx6lyq1hcp327v813e1t38k241sx.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Customizable request forms",
                iconRef: "mail-icon"
            }
        ]
    },
    {
        templateId: "customer-service-management",
        name: "Customer service management",
        oneLinerHeadline: "Deliver great service experiences for your external customers.",
        urlSlug: "customer-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:0abefbb4-6cfd-4163-829a-fcf2db0b99e7/var2%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/2b83vv62ssm4g2km1m7638d126w2e1u3.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Developer escalations",
                iconRef: "flag-icon"
            },
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            }
        ]
    },
    {
        templateId: "marketing-service-management",
        name: "Marketing service management",
        oneLinerHeadline: "Manage and track all your marketing requests.",
        urlSlug: "marketing-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/g13dr33528x350811shfr52mr5y5hr72.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Forms for Marketing requests",
                iconRef: "mail-icon"
            },
            {
                name: "Reports",
                iconRef: "data-points-icon"
            }
        ]
    },
    {
        templateId: "design-service-management",
        name: "Design service management",
        oneLinerHeadline: "Manage and track all your design requests.",
        urlSlug: "design-service-management",
        templateIcon: {
            name: "Help Center screenshot",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/e4tgp6i7841gcfb7wf43k0j6a2576264.svg",
            description: "Help Center screenshot"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Automated design workflows",
                iconRef: "workflow-icon"
            }
        ]
    },
    {
        templateId: "finance-service-management",
        name: "Finance service management",
        oneLinerHeadline: "Manage and track budget, spend, and other finance requests.",
        urlSlug: "finance-service-management",
        templateIcon: {
            name: "Form view",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/401876mvht4ti1a070a3s3o3t3i6s51u.svg",
            description: "Form view"
        },
        keyFeatures: [
            {
                name: "Forms for Finance requests",
                iconRef: "mail-icon"
            },
            {
                name: "Reporting and tracking",
                iconRef: "data-points-icon"
            }
        ]
    },
    {
        templateId: "analytics-service-management",
        name: "Analytics service management",
        oneLinerHeadline: "Manage employee requests for the data and insights they need.",
        urlSlug: "analytics-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:95aef340-57e7-4ec1-a92d-cbda63b1814e/var1%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/hqvjo4k71u4x3y6e2nkden08471f4e47.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Automated Analytics workflows",
                iconRef: "robot-icon"
            }
        ]
    },
    {
        templateId: "facilities-service-management",
        name: "Facilities service management",
        oneLinerHeadline: "Manage requests for maintenance, moving, and event planning.",
        urlSlug: "facilities-service-management",
        templateIcon: {
            name: "Help center screenshot",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/18xqw35pw8do7ru0wp3d8oscs2fmw1mf.svg",
            description: "Help center screenshot"
        },
        keyFeatures: [
            {
                name: "Forms for Facilities requests",
                iconRef: "mail-icon"
            },
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            }
        ]
    },
    {
        templateId: "sales-service-management",
        name: "Sales service management",
        oneLinerHeadline: "Manage, track, and report on all your sales requests.",
        urlSlug: "sales-service-management",
        templateIcon: {
            name: "Kanban board",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:0abefbb4-6cfd-4163-829a-fcf2db0b99e7/var2%20for%20JSM%20templates.svg?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/1k3k7o8j66265rdk5e6vj0o23g611j04.svg",
            description: "Kanban board"
        },
        keyFeatures: [
            {
                name: "Forms designed for Sales requests",
                iconRef: "mail-icon"
            },
            {
                name: "Reporting and tracking",
                iconRef: "data-points-icon"
            }
        ]
    },
    {
        templateId: "legal-service-management",
        name: "Legal service management",
        oneLinerHeadline: "Manage and track all your contracts and legal requests.",
        urlSlug: "legal-service-management",
        templateIcon: {
            name: "Jira roadmap",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:b7e76c98-78d2-4c35-9cf3-a30b6f888dc1/Screen_HelpCenter.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/47k1ynn8f0024m4tg2vd6omf3jr60h7u.svg",
            description: "Jira roadmap"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Customer portal to take requests",
                iconRef: "mail-icon"
            }
        ]
    },
    {
        templateId: "general-service-management",
        name: "General service management",
        oneLinerHeadline: "Collect, prioritize, and manage requests for any business teams.",
        urlSlug: "general-service-management",
        templateIcon: {
            name: "Queues view",
            size: 200,
            url: "https://wac-cdn.atlassian.com/dam/jcr:f4f1a80b-82c9-4951-878a-ce360fb2da9d/Screen_Queues.png?cdnVersion=2319",
            refreshUrl: "https://dam-cdn.atl.orangelogic.com/AssetLink/2x43564ibsn386dk7g764353rk2341n2.svg",
            description: "Queues view"
        },
        keyFeatures: [
            {
                name: "Self-service and FAQ help center",
                iconRef: "help-icon"
            },
            {
                name: "Customer portal to take requests",
                iconRef: "mail-icon"
            }
        ]
    }
];

});

parcelRegister("8Sr8q", function(module, exports) {
$parcel$export(module.exports, "Resources", function () { return $cfe011856ec0428b$export$e9a269813a6315a4; });
/* resources.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");

var $1rGpC = parcelRequire("1rGpC");
const $cfe011856ec0428b$var$backgroundStyles = null;
const $cfe011856ec0428b$var$h2Styles = null;
const $cfe011856ec0428b$var$h4Styles = null;
const $cfe011856ec0428b$var$pStyles = null;
const $cfe011856ec0428b$var$linkStyles = null;
const $cfe011856ec0428b$export$e9a269813a6315a4 = ()=>{
    const intl = (0, $8e22h.default)();
    const resources = [
        {
            heading: intl.formatMessage({
                id: "jsm.templates.resources.gettingStartedGuide",
                defaultMessage: "Getting started guide"
            }),
            description: intl.formatMessage({
                id: "jsm.templates.resources.gettingStartedGuideDescription",
                defaultMessage: "Everything you need to know about getting started with Jira Service Management."
            }),
            link: {
                text: intl.formatMessage({
                    id: "jsm.templates.resources.gettingStartedGuideLink",
                    defaultMessage: "Go to guide"
                }),
                href: (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/product-guide/getting-started/quick-start-guide"),
                type: "primary"
            }
        },
        {
            heading: intl.formatMessage({
                id: "jsm.templates.resources.productGuide",
                defaultMessage: "Jira Service Management product guides"
            }),
            description: intl.formatMessage({
                id: "jsm.templates.resources.productGuideDescription",
                defaultMessage: "How to use Jira Service Management: guides, tutorials, and demos."
            }),
            link: {
                text: intl.formatMessage({
                    id: "jsm.templates.resources.productGuideLink",
                    defaultMessage: "Review the guide"
                }),
                href: (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/product-guide"),
                type: "primary"
            }
        },
        {
            heading: intl.formatMessage({
                id: "jsm.templates.resources.demo",
                defaultMessage: "Jira Service Management demo"
            }),
            description: intl.formatMessage({
                id: "jsm.templates.resources.demoDescription",
                defaultMessage: "Choose specific features you\u2019re interested in and we\u2019ll personalize a demo for you."
            }),
            link: {
                text: intl.formatMessage({
                    id: "jsm.templates.resources.demoLink",
                    defaultMessage: "Watch the demo"
                }),
                href: (0, $jQ0cd.useLocalizedHref)("/software/jira/service-management/demo"),
                type: "primary"
            }
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1itk1ejp _12vemgnk _1lrw1wug _1bsb1osq _ca0qgktf _u5f37vkz _n3tdckbl _19bv7vkz _1akockbl _c7s77vkz _4puvvbgk _1r3v7vkz _3int1h90 _4fuggrf3 _1ynq1h90 _1j3ngrf3 _ip651h90 _g8ou1h90 _1opi1h90 _1x951h90"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                className: (0, $2jatx.default)([
                    "_syazmcao _1wybk299 _k48p124r _vwz42a8g _y3gn1qpp _19pkgrf3 _2hwx1h90 _otyrgrf3 _18u01h90 _ca0q7vkz _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _1ako1crf _c7s77vkz _4puv1crf _1r3v7vkz _1s18r6mz _uj6k1s23"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                    id: "resources.heading",
                    defaultMessage: "Service management resources"
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                layout: "4-4-4",
                children: resources.map((resource, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h4", {
                                className: (0, $2jatx.default)([
                                    "_syazmcao _k48p124r _vwz4cjiy _6rth1usy _1wyb19as _1dyzzyni _1s18n2z8"
                                ]),
                                children: resource.heading
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_syazt5hr _1wyb1j6v _k48pl8b6 _vwz41k8s _6rth1x4e"
                                ]),
                                children: resource.description
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                ...resource.link,
                                className: (0, $2jatx.default)([
                                    "_v56412xp"
                                ])
                            })
                        ]
                    }, index))
            })
        ]
    });
};

});

parcelRegister("8AvPJ", function(module, exports) {
$parcel$export(module.exports, "SharedHeaderFooterContainer", function () { return $37d8fa01f56156a9$export$93790172861f3d8b; });

var $7VQPk = parcelRequire("7VQPk");

var $20OkY = parcelRequire("20OkY");

var $iHYHa = parcelRequire("iHYHa");

var $iLjCW = parcelRequire("iLjCW");

var $aYVVm = parcelRequire("aYVVm");
const $37d8fa01f56156a9$export$93790172861f3d8b = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $aYVVm.default), {}),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iHYHa.SiteSelectorContextProvider), {
                productKey: (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK,
                analyticsPrefix: "wac.showroom",
                internalLinkAfterIdentity: "/team-playbook/plays/choose-your-site",
                children: children
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
        ]
    });
};

});

parcelRegister("2fCHu", function(module, exports) {
$parcel$export(module.exports, "TemplatesGrid", function () { return $fc0f390a3f68e4b0$export$e845b3e887ad68a4; });
/* templates-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $5LkDU = parcelRequire("5LkDU");

var $1rGpC = parcelRequire("1rGpC");
const $fc0f390a3f68e4b0$var$fontCharlieDisplay = `"Charlie Display", "Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`;
const $fc0f390a3f68e4b0$var$fontCharlieText = `"Charlie Text", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Noto Sans", Ubuntu, "Droid Sans", "Helvetica Neue", sans-serif`;
const $fc0f390a3f68e4b0$var$backgroundStyles = null;
const $fc0f390a3f68e4b0$var$containerStyles = null;
const $fc0f390a3f68e4b0$var$titleStyles = null;
const $fc0f390a3f68e4b0$var$h1Styles = null;
const $fc0f390a3f68e4b0$var$pStyles = null;
const $fc0f390a3f68e4b0$var$gridContainerStyles = null;
const $fc0f390a3f68e4b0$export$e845b3e887ad68a4 = ({ templates: templates })=>{
    const templateGridRows = ()=>{
        const rows = [];
        for(let i = 0; i < templates.length; i += 3)rows.push(templates.slice(i, i + 3));
        return rows;
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1itk12hr _12vemgnk _1reoidpf _18m9idpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_ahbq1wug _12l21wug _85i57vkz _1q517vkz _p12f1fra _1yd316xz _1waf16xz"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_ahbq1wug _12l21wug _1bsb1osq _bozg7vkz _y4ti7vkz _85i5zwfg _14b5m8w4 _uj6k1h6o _1yd3vbgk _glte2c62 _40tuvbgk"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                            className: (0, $2jatx.default)([
                                "_syazmcao _vwz4zz36 _ect41bwv _k48p53lb _1pfhidpf _6rth7vkz _1wyb14b4 _1s181a5d _3p1cxxch"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "jsm.templates.page.title",
                                defaultMessage: "Service management templates"
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                            className: (0, $2jatx.default)([
                                "_syazi7uo _ect41fn2"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "jsm.templates.page.subtitle",
                                defaultMessage: "Empower any team to get started with a service experience in Jira Service Management with pre-configured request types, workflows, and automations."
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    "data-testid": "templates-grid",
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _bozg1gpt _y4ti1gpt _9bbqgrf3 _1qqcgrf3"
                    ]),
                    children: templateGridRows().map((row, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $1rGpC.Row), {
                            layout: "4-4-4",
                            children: row.map((template)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $5LkDU.TemplateCard), {
                                    template: template
                                }, template.urlSlug))
                        }, `template-grid-row-${index}`))
                })
            ]
        })
    });
};

});
parcelRegister("5LkDU", function(module, exports) {
$parcel$export(module.exports, "TemplateCard", function () { return $5795f296170cd462$export$ba340e850b866867; });
/* template-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $92jF6 = parcelRequire("92jF6");

var $kbpa7 = parcelRequire("kbpa7");

var $jSj3N = parcelRequire("jSj3N");
const $5795f296170cd462$var$colorN700 = "#253858";
const $5795f296170cd462$var$containerStyles = null;
const $5795f296170cd462$export$ba340e850b866867 = ({ template: template })=>{
    const intl = (0, $8e22h.default)();
    const url = template.urlSlug ? `/software/jira/templates/${template.urlSlug}` : "";
    const messages = // @ts-ignore
    (0, $jSj3N.JiraServiceManagementTemplateMessageMap)[template.templateId];
    if (messages) return /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
        href: url ?? "",
        className: (0, $2jatx.default)([
            "_z5uk1h67 _1boa1h67 _16it1h67 _ad5c1h67 _1rhqmcao _8kc9n2z8 _1euyw0jn _k6x01gpt _125xmcao _q7gq19as _zcqxk299 _1ayngrf3 _16qsl45a _v564mihd _1dbz1x6p _858u8ben _2rko1wa3 _1reo15vq _18m915vq _1ilwgrf3"
        ]),
        style: {
            "--_w9vrer": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1100")),
            "--_nl5by5": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue1000"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $92jF6.Card), {
            className: "template-card",
            "data-testid": "template-card",
            headerText: intl.formatMessage(messages.name),
            headerType: "h4",
            bodyText: intl.formatMessage(messages.oneLinerHeadline),
            backgroundColor: (0, $kbpa7.wacToken)("color.neutral.light100"),
            textColor: $5795f296170cd462$var$colorN700,
            clickableCardUrl: url ?? "",
            pictureProps: {
                image: {
                    src: template.templateIcon?.url ?? "",
                    alt: intl.formatMessage(messages.iconDescription) ?? ""
                }
            }
        })
    });
    return null;
};

});
parcelRegister("92jF6", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $b6adcd00aae9005f$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2ivuE = parcelRequire("2ivuE");
const $b6adcd00aae9005f$var$containerStyles = null;
const $b6adcd00aae9005f$var$contentBlockStyles = null;
const $b6adcd00aae9005f$var$barStyles = null;
const $b6adcd00aae9005f$export$60332b2344f7fe41 = (props)=>{
    const { textColor: textColor, headerType: headerType, headerText: headerText, bodyText: bodyText, eyebrowText: eyebrowText, footerHeader: footerHeader, footerText: footerText, imageLink: imageLink, imageAltText: imageAltText, backgroundColor: backgroundColor, colorBars: colorBars, iconName: iconName, iconColor: iconColor, iconSize: iconSize, barColor: barColor = "", className: className, ctaProps: ctaProps, aspectRatio: aspectRatio, orientation: orientation, pictureProps: pictureProps, clickableCardUrl: clickableCardUrl } = props;
    if (imageLink && !imageAltText) throw new Error("If using an image, please provide an alt text for accessibility purposes!");
    const cardBackBackgroundColor = backgroundColor ?? "#ffffff";
    const cardBackTextColor = textColor ?? "#091e42";
    const cardBackColor = null;
    const contentBlockIconColor = iconColor ?? "#091e42";
    const handleClick = ()=>{
        if (clickableCardUrl) window.location.href = clickableCardUrl;
    };
    const clickableCardStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_2rkoyh40 _16qs1nta _1e0c1txw _2lx21bp4 _p12fg505 _7cca15wb _4t3i1osq",
            "_bfhk16d1 _syazn54i",
            "_80om1wzl",
            className
        ]),
        onClick: handleClick,
        style: {
            "--_1vkwvj7": (0, $6ZVlx.default)(cardBackBackgroundColor),
            "--_1dl5pj2": (0, $6ZVlx.default)(cardBackTextColor),
            "--_8vvi5m": (0, $6ZVlx.default)(clickableCardUrl ? "pointer" : "default")
        },
        children: [
            colorBars === "top" || colorBars === "both" ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderTopRightRadius: "4px",
                    borderTopLeftRadius: "4px"
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : "",
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2ivuE.ContentBlock), {
                cardStyle: true,
                aspectRatio: aspectRatio,
                orientation: orientation,
                headerType: headerType,
                headerText: headerText,
                bodyText: bodyText,
                imageLink: imageLink,
                imageAltText: imageAltText,
                eyebrowText: eyebrowText,
                footerHeader: footerHeader,
                footerText: footerText,
                iconColor: contentBlockIconColor,
                iconName: iconName,
                iconSize: iconSize,
                ctaProps: ctaProps,
                pictureProps: pictureProps,
                className: (0, $2jatx.default)([
                    "_4t3i1osq"
                ])
            }),
            colorBars === "bottom" || colorBars === "both" ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    backgroundColor: barColor,
                    borderBottomRightRadius: "4px",
                    borderBottomLeftRadius: "4px"
                },
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1osq _4t3iftgi"
                ])
            }) : ""
        ]
    });
};

});

parcelRegister("jSj3N", function(module, exports) {
$parcel$export(module.exports, "JiraServiceManagementTemplateMessageMap", function () { return $5cab63bd7c1076be$export$7eb612acc27aff49; });

var $fnHPc = parcelRequire("fnHPc");
const $5cab63bd7c1076be$export$7d34f3deca703e17 = (0, $fnHPc.defineMessages)({
    "it-service-managementName": {
        id: "jsm.templates.it-service-management.name",
        defaultMessage: "IT service management"
    },
    "it-service-managementOneLinerHeadline": {
        id: "jsm.templates.it-service-management.oneLinerHeadline",
        defaultMessage: "Intake requests, set up alerts, raise incidents, and fix issues quickly."
    },
    "it-service-managementIconName": {
        id: "jsm.templates.it-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "it-service-managementIconDescription": {
        id: "jsm.templates.it-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "it-service-managementFeature-1": {
        id: "jsm.templates.it-service-management.feature-1",
        defaultMessage: "Alerts and on-call schedules"
    },
    "it-service-managementFeature-2": {
        id: "jsm.templates.it-service-management.feature-2",
        defaultMessage: "Multi-channel support"
    },
    "advanced-it-service-managementName": {
        id: "jsm.templates.advanced-it-service-management.name",
        defaultMessage: "Advanced IT service management"
    },
    "advanced-it-service-managementOneLinerHeadline": {
        id: "jsm.templates.advanced-it-service-management.oneLinerHeadline",
        defaultMessage: "Incident, change, and problem management with ITSM best practices."
    },
    "advanced-it-service-managementIconName": {
        id: "jsm.templates.advanced-it-service-management.templateIcon.name",
        defaultMessage: "Help Center screenshot"
    },
    "advanced-it-service-managementIconDescription": {
        id: "jsm.templates.advanced-it-service-management.templateIcon.description",
        defaultMessage: "Help Center screenshot"
    },
    "advanced-it-service-managementFeature-1": {
        id: "jsm.templates.advanced-it-service-management.feature-1",
        defaultMessage: "Automated change requests"
    },
    "advanced-it-service-managementFeature-2": {
        id: "jsm.templates.advanced-it-service-management.feature-2",
        defaultMessage: "Alerts and on-call schedules"
    },
    "hr-service-managementName": {
        id: "jsm.templates.hr-service-management.name",
        defaultMessage: "HR service management"
    },
    "hr-service-managementOneLinerHeadline": {
        id: "jsm.templates.hr-service-management.oneLinerHeadline",
        defaultMessage: "Manage onboarding and offboarding and respond to HR requests."
    },
    "hr-service-managementIconName": {
        id: "jsm.templates.hr-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "hr-service-managementIconDescription": {
        id: "jsm.templates.hr-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "hr-service-managementFeature-1": {
        id: "jsm.templates.hr-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "hr-service-managementFeature-2": {
        id: "jsm.templates.hr-service-management.feature-2",
        defaultMessage: "Customizable request forms"
    },
    "customer-service-managementName": {
        id: "jsm.templates.customer-service-management.name",
        defaultMessage: "Customer service management"
    },
    "customer-service-managementOneLinerHeadline": {
        id: "jsm.templates.customer-service-management.oneLinerHeadline",
        defaultMessage: "Deliver great service experiences for your external customers."
    },
    "customer-service-managementIconName": {
        id: "jsm.templates.customer-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "customer-service-managementIconDescription": {
        id: "jsm.templates.customer-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "customer-service-managementFeature-1": {
        id: "jsm.templates.customer-service-management.feature-1",
        defaultMessage: "Developer escalations"
    },
    "customer-service-managementFeature-2": {
        id: "jsm.templates.customer-service-management.feature-2",
        defaultMessage: "Self-service and FAQ help center"
    },
    "marketing-service-managementName": {
        id: "jsm.templates.marketing-service-management.name",
        defaultMessage: "Marketing service management"
    },
    "marketing-service-managementOneLinerHeadline": {
        id: "jsm.templates.marketing-service-management.oneLinerHeadline",
        defaultMessage: "Manage and track all your marketing requests."
    },
    "marketing-service-managementIconName": {
        id: "jsm.templates.marketing-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "marketing-service-managementIconDescription": {
        id: "jsm.templates.marketing-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "marketing-service-managementFeature-1": {
        id: "jsm.templates.marketing-service-management.feature-1",
        defaultMessage: "Forms for Marketing requests"
    },
    "marketing-service-managementFeature-2": {
        id: "jsm.templates.marketing-service-management.feature-2",
        defaultMessage: "Reports"
    },
    "design-service-managementName": {
        id: "jsm.templates.design-service-management.name",
        defaultMessage: "Design service management"
    },
    "design-service-managementOneLinerHeadline": {
        id: "jsm.templates.design-service-management.oneLinerHeadline",
        defaultMessage: "Manage and track all your design requests."
    },
    "design-service-managementIconName": {
        id: "jsm.templates.design-service-management.templateIcon.name",
        defaultMessage: "Help Center screenshot"
    },
    "design-service-managementIconDescription": {
        id: "jsm.templates.design-service-management.templateIcon.description",
        defaultMessage: "Help Center screenshot"
    },
    "design-service-managementFeature-1": {
        id: "jsm.templates.design-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "design-service-managementFeature-2": {
        id: "jsm.templates.design-service-management.feature-2",
        defaultMessage: "Automated design workflows"
    },
    "finance-service-managementName": {
        id: "jsm.templates.finance-service-management.name",
        defaultMessage: "Finance service management"
    },
    "finance-service-managementOneLinerHeadline": {
        id: "jsm.templates.finance-service-management.oneLinerHeadline",
        defaultMessage: "Manage and track budget, spend, and other finance requests."
    },
    "finance-service-managementIconName": {
        id: "jsm.templates.finance-service-management.templateIcon.name",
        defaultMessage: "Form view"
    },
    "finance-service-managementIconDescription": {
        id: "jsm.templates.finance-service-management.templateIcon.description",
        defaultMessage: "Form view"
    },
    "finance-service-managementFeature-1": {
        id: "jsm.templates.finance-service-management.feature-1",
        defaultMessage: "Forms for Finance requests"
    },
    "finance-service-managementFeature-2": {
        id: "jsm.templates.finance-service-management.feature-2",
        defaultMessage: "Reporting and tracking"
    },
    "analytics-service-managementName": {
        id: "jsm.templates.analytics-service-management.name",
        defaultMessage: "Analytics service management"
    },
    "analytics-service-managementOneLinerHeadline": {
        id: "jsm.templates.analytics-service-management.oneLinerHeadline",
        defaultMessage: "Manage employee requests for the data and insights they need."
    },
    "analytics-service-managementIconName": {
        id: "jsm.templates.analytics-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "analytics-service-managementIconDescription": {
        id: "jsm.templates.analytics-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "analytics-service-managementFeature-1": {
        id: "jsm.templates.analytics-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "analytics-service-managementFeature-2": {
        id: "jsm.templates.analytics-service-management.feature-2",
        defaultMessage: "Automated Analytics workflows"
    },
    "facilities-service-managementName": {
        id: "jsm.templates.facilities-service-management.name",
        defaultMessage: "Facilities service management"
    },
    "facilities-service-managementOneLinerHeadline": {
        id: "jsm.templates.facilities-service-management.oneLinerHeadline",
        defaultMessage: "Manage requests for maintenance, moving, and event planning."
    },
    "facilities-service-managementIconName": {
        id: "jsm.templates.facilities-service-management.templateIcon.name",
        defaultMessage: "Help center screenshot"
    },
    "facilities-service-managementIconDescription": {
        id: "jsm.templates.facilities-service-management.templateIcon.description",
        defaultMessage: "Help center screenshot"
    },
    "facilities-service-managementFeature-1": {
        id: "jsm.templates.facilities-service-management.feature-1",
        defaultMessage: "Forms for Facilities requests"
    },
    "facilities-service-managementFeature-2": {
        id: "jsm.templates.facilities-service-management.feature-2",
        defaultMessage: "Self-service and FAQ help center"
    },
    "sales-service-managementName": {
        id: "jsm.templates.sales-service-management.name",
        defaultMessage: "Sales service management"
    },
    "sales-service-managementOneLinerHeadline": {
        id: "jsm.templates.sales-service-management.oneLinerHeadline",
        defaultMessage: "Manage, track, and report on all your sales requests."
    },
    "sales-service-managementIconName": {
        id: "jsm.templates.sales-service-management.templateIcon.name",
        defaultMessage: "Kanban board"
    },
    "sales-service-managementIconDescription": {
        id: "jsm.templates.sales-service-management.template    .Icon.description",
        defaultMessage: "Kanban board"
    },
    "sales-service-managementFeature-1": {
        id: "jsm.templates.sales-service-management.feature-1",
        defaultMessage: "Forms designed for Sales requests"
    },
    "sales-service-managementFeature-2": {
        id: "jsm.templates.sales-service-management.feature-2",
        defaultMessage: "Reporting and tracking"
    },
    "legal-service-managementName": {
        id: "jsm.templates.legal-service-management.name",
        defaultMessage: "Legal service management"
    },
    "legal-service-managementOneLinerHeadline": {
        id: "jsm.templates.legal-service-management.oneLinerHeadline",
        defaultMessage: "Manage and track all your contracts and legal requests."
    },
    "legal-service-managementIconName": {
        id: "jsm.templates.legal-service-management.templateIcon.name",
        defaultMessage: "Jira roadmap"
    },
    "legal-service-managementIconDescription": {
        id: "jsm.templates.legal-service-management.templateIcon.description",
        defaultMessage: "Jira roadmap"
    },
    "legal-service-managementFeature-1": {
        id: "jsm.templates.legal-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "legal-service-managementFeature-2": {
        id: "jsm.templates.legal-service-management.feature-2",
        defaultMessage: "Customer portal to take requests"
    },
    "general-service-managementName": {
        id: "jsm.templates.general-service-management.name",
        defaultMessage: "General service management"
    },
    "general-service-managementOneLinerHeadline": {
        id: "jsm.templates.general-service-management.oneLinerHeadline",
        defaultMessage: "Collect, prioritize, and manage requests for any business teams."
    },
    "general-service-managementIconName": {
        id: "jsm.templates.general-service-management.templateIcon.name",
        defaultMessage: "Queues view"
    },
    "general-service-managementIconDescription": {
        id: "jsm.templates.general-service-management.templateIcon.description",
        defaultMessage: "Queues view"
    },
    "general-service-managementFeature-1": {
        id: "jsm.templates.general-service-management.feature-1",
        defaultMessage: "Self-service and FAQ help center"
    },
    "general-service-managementFeature-2": {
        id: "jsm.templates.general-service-management.feature-2",
        defaultMessage: "Customer portal to take requests"
    }
});
const $5cab63bd7c1076be$export$7eb612acc27aff49 = {
    "it-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["it-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["it-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["it-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["it-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["it-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["it-service-managementFeature-2"]
        ]
    },
    "advanced-it-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["advanced-it-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["advanced-it-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["advanced-it-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["advanced-it-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["advanced-it-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["advanced-it-service-managementFeature-2"]
        ]
    },
    "hr-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["hr-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["hr-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["hr-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["hr-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["hr-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["hr-service-managementFeature-2"]
        ]
    },
    "customer-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["customer-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["customer-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["customer-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["customer-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["customer-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["customer-service-managementFeature-2"]
        ]
    },
    "marketing-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["marketing-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["marketing-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["marketing-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["marketing-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["marketing-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["marketing-service-managementFeature-2"]
        ]
    },
    "design-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["design-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["design-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["design-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["design-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["design-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["design-service-managementFeature-2"]
        ]
    },
    "finance-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["finance-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["finance-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["finance-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["finance-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["finance-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["finance-service-managementFeature-2"]
        ]
    },
    "analytics-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["analytics-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["analytics-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["analytics-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["analytics-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["analytics-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["analytics-service-managementFeature-2"]
        ]
    },
    "facilities-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["facilities-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["facilities-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["facilities-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["facilities-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["facilities-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["facilities-service-managementFeature-2"]
        ]
    },
    "sales-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["sales-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["sales-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["sales-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["sales-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["sales-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["sales-service-managementFeature-2"]
        ]
    },
    "legal-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["legal-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["legal-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["legal-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["legal-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["legal-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["legal-service-managementFeature-2"]
        ]
    },
    "general-service-management": {
        name: $5cab63bd7c1076be$export$7d34f3deca703e17["general-service-managementName"],
        oneLinerHeadline: $5cab63bd7c1076be$export$7d34f3deca703e17["general-service-managementOneLinerHeadline"],
        iconName: $5cab63bd7c1076be$export$7d34f3deca703e17["general-service-managementIconName"],
        iconDescription: $5cab63bd7c1076be$export$7d34f3deca703e17["general-service-managementIconDescription"],
        keyFeatures: [
            $5cab63bd7c1076be$export$7d34f3deca703e17["general-service-managementFeature-1"],
            $5cab63bd7c1076be$export$7d34f3deca703e17["general-service-managementFeature-2"]
        ]
    }
};

});






var $3NQOU = parcelRequire("3NQOU");

var $keOu4 = parcelRequire("keOu4");
(0, $3NQOU.init)((0, $keOu4.JiraTemplateCategoryPage));


//# sourceMappingURL=jira-template-category-page.9ba86c70.js.map
